import { Form } from "antd";
import { CustomButton } from "@Components/Button";
import ArrowRight from "@Assets/icons/arrow-right.svg";
import UnAuthHeader from "../UnAuthHeader";
import { NavigationRoutes } from "@Navigation/NavigationRoutes";
import OTPInput from "@Components/OtpInput/OtpInput";
import useOtpContainer from "./useOtpContainer";

const OtpVerication = () => {
  const {
    navigate,
    otp,
    setOTP,
    form,
    handleSubmit,
    isVerifyingUser,
    canResend,
    timeLeftFormatted,
    handleResendOtp,
    isResendingOtp,
  } = useOtpContainer();

  return (
    <div className="flex justify-center items-center w-full px-4 sm:px-6 md:px-8 py-4 sm:py-6 md:py-8">
      <div className="py-4 sm:py-6 px-6 bg-white w-full max-w-[360px] sm:max-w-[400px] 2xl:max-w-[448px] min-h-[300px] 2xl:min-h-[350px] rounded-[18px] shadow-md">
        <UnAuthHeader
          headerTitle="OTP"
          subTitle="Enter the 6-digit code sent to your email."
        />

        <div className="px-2 !mb-4  ">
          <Form form={form} initialValues={{ otp: otp }} className="py-2">
            <Form.Item
              validateStatus={otp.join("").length < 6 ? "error" : undefined}
              help={
                otp.join("").length < 6
                  ? "Please enter the 6-digit code."
                  : undefined
              }
              className="!mb-0"
            >
              <OTPInput length={6} otp={otp} setOTP={setOTP} />
            </Form.Item>

            <div className="text-center">
              <p className="text-[#575757] text-[14px] sm:text-[14px] font-[500]">
                Didn't receive the code?
                <span
                  className={`ml-1 font-[600] text-[#F97316] ${
                    canResend && !isResendingOtp
                      ? "cursor-pointer"
                      : "pointer-events-none opacity-70"
                  }`}
                  onClick={handleResendOtp}
                  title={
                    canResend ? "Tap to resend and start timer" : undefined
                  }
                >
                  ({timeLeftFormatted})
                </span>
              </p>
            </div>
            <Form.Item className="text-center max-w-full !pt-2">
              <CustomButton
                title={"Verify"}
                shape="round"
                btnColor="danger"
                type="primary"
                iconPosition="right"
                icon={<ArrowRight />}
                className="w-full h-[44px] sm:h-[50px] font-bold tracking-[1%] !rounded-[12px] text-sm sm:text-base"
                htmlType="button"
                isLoading={isVerifyingUser}
                disabled={isVerifyingUser}
                onClick={handleSubmit}
              />
            </Form.Item>
            <div className="text-center">
              <p className="text-[#575757] text-[14px] sm:text-[14px] font-[500]">
                Back to{" "}
                <span
                  className="text-[#111827] font-[500] cursor-pointer"
                  onClick={() => navigate(NavigationRoutes.AUTH_ROUTES.LOGIN)}
                >
                  Login
                </span>
              </p>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default OtpVerication;
